// src/neetjee_guru/graphql/academicPlannerQueries.js
import gql from "graphql-tag";

/**
 * Fetch master academic planner with mapped day topics, exam metadata, and section progress
 */
export const GET_ACADEMIC_PLANNER_DETAILS = gql`
  query GetAcademicPlannerDetails(
    $academicPlannerId: ID!
    $startDate: String
    $endDate: String
    $branchId: String
    $sectionName: String
  ) {
    getAcademicPlannerDetails(
      academic_planner_id: $academicPlannerId
      start_date: $startDate
      end_date: $endDate
      branch_id: $branchId
      section_name: $sectionName
    ) {
      id
      academic_planner_id
      academic_phase_id
      schedule_date
      day_number
      week_number
      subject_name
      topic_title
      day_type
      sub_type
      exam_title
      section_progress_json
      overall_status
      updated_by
      updated_at
    }
  }
`;

/**
 * Fetch list of available master planners with their scope map details
 */
export const GET_ACADEMIC_PLANNERS = gql`
  query GetAcademicPlanners($institution_id: Int, $academicYearId: Int) {
    getAcademicPlanners(institution_id: $institution_id, academic_year_id: $academicYearId) {
      id
      institution_id
      academic_planner
      academic_year_id
      stream_name
      estatus
      map_details {
        id
        academic_planner_id
        state_ids
        branch_ids
        class_ids
        section_ids
        estatus
      }
    }
  }
`;

/**
 * Fetch academic phases (e.g. Phase 1 - Foundation, Phase 2 - Core, Phase 3 - Revision)
 */
export const GET_ACADEMIC_PHASES = gql`
  query GetAcademicPhases {
    getAcademicPhases {
      id
      academic_phase
      estatus
    }
  }
`;

/**
 * Mutation to edit topic title, day classification type, sub-type, or exam title
 */
export const UPDATE_PLANNER_DETAIL = gql`
  mutation UpdatePlannerDetail($input: UpdatePlannerDetailInput!) {
    updatePlannerDetail(input: $input) {
      success
      message
      affected_rows
    }
  }
`;

/**
 * Mutation for faculty / teacher to update teaching progress per section
 */
export const UPDATE_TEACHING_PROGRESS = gql`
  mutation UpdateTeachingProgress($input: UpdateTeachingProgressInput!) {
    updateTeachingProgress(input: $input) {
      success
      message
      affected_rows
    }
  }
`;

/**
 * Mutation for bulk date shifting (unexpected holidays / rain days)
 */
export const BULK_SHIFT_PLANNER_SCHEDULE = gql`
  mutation BulkShiftPlannerSchedule($input: BulkShiftPlannerInput!) {
    bulkShiftPlannerSchedule(input: $input) {
      success
      message
      affected_rows
    }
  }
`;

/**
 * Mutation to create a new Master Academic Planner, phase link, and target map
 */
export const CREATE_ACADEMIC_PLANNER = gql`
  mutation CreateAcademicPlanner($input: CreateAcademicPlannerInput!) {
    createAcademicPlanner(input: $input) {
      success
      message
      affected_rows
      planner_id
    }
  }
`;

/**
 * Mutation to bulk insert planner details rows from CSV upload
 */
export const BULK_INSERT_PLANNER_DETAILS = gql`
  mutation BulkInsertPlannerDetails($academic_planner_id: ID!, $rows: [PlannerDetailRowInput!]!) {
    bulkInsertPlannerDetails(academic_planner_id: $academic_planner_id, rows: $rows) {
      success
      message
      affected_rows
    }
  }
`;/**
 * Mutation to update master academic planner details
 */
export const UPDATE_ACADEMIC_PLANNER = gql`
  mutation UpdateAcademicPlanner($id: ID!, $academic_planner: String, $stream_name: String, $academic_year_id: Int, $estatus: Int) {
    updateAcademicPlanner(id: $id, academic_planner: $academic_planner, stream_name: $stream_name, academic_year_id: $academic_year_id, estatus: $estatus) {
      success
      message
    }
  }
`;

/**
 * Mutation to update planner scope mapping (branch_ids, section_ids, class_ids)
 */
export const UPDATE_PLANNER_MAP = gql`
  mutation UpdatePlannerMap($academic_planner_id: ID!, $branch_ids: String, $section_ids: String, $class_ids: String, $state_ids: String) {
    updatePlannerMap(academic_planner_id: $academic_planner_id, branch_ids: $branch_ids, section_ids: $section_ids, class_ids: $class_ids, state_ids: $state_ids) {
      success
      message
    }
  }
`;


// ─── Live Form Data Queries ─────────────────────────────────────────────────

/**
 * Fetch all campus branches for the institution (uses institution_id from cookie)
 */
export const GET_BRANCHES_FOR_PLANNER = gql`
  query GetBranchesForPlanner($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        section_name
        class_id
      }
    }
  }
`;

/**
 * Fetch sections for a specific branch
 */
export const GET_SECTION_NAMES = gql`
  query GetSectionNames($institution_id: Int!, $branch_id: Int!) {
    getSectionNames(institution_id: $institution_id, branch_id: $branch_id) {
      id
      section_name
    }
  }
`;

/**
 * Fetch academic years for the academic year selector
 */
export const GET_ACADEMIC_YEARS = gql`
  query GetAcademicYears($id: Int) {
    getAcademicYears(id: $id) {
      id
      academic_year
    }
  }
`;


